export const usersText = {
  EDIT_USER: "Edit user",
  DELETE_USER: "Delete user",
  DELETE_USER_WARNING: (email: string) =>
    `Are you sure you want to delete this user ${email}? This action cannot be undone.`,
  DELETED_USER_SNACKBAR: (email: string) => `User ${email} has been deleted successfully`,
  INVITE_USER_SUCCESS_SNACKBAR: "User successfully invited",
  PROFILE_SAVING_CHANGES_SNACKBAR: "Saving changes...",
};
